import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=6e4e791b&scoped=true&"
import script from "./FormControl.vue?vue&type=script&lang=ts&"
export * from "./FormControl.vue?vue&type=script&lang=ts&"
import style0 from "./FormControl.vue?vue&type=style&index=0&id=6e4e791b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e791b",
  null
  
)

export default component.exports